module.exports = __webpack_public_path__ + "static/img/08.f155eac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/apps/loyaltyvenue/tutorial/08.svg
// module id = sQ39
// module chunks = 13